export default __webpack_public_path__ + "static/media/15.323d4af4.png";